// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';

import RequiresAttentionCell from './RequiresAttentionCell';

/**
 * react-data-table-component column shape (see normalize-columns.js — a string
 * `name` is auto-wrapped in a Typography, every other key spread through untouched).
 * Pure-data columns use `selector`; "Requires Attention" uses a `cell` so it can
 * mount a live per-row indicator that watches the RHF model. Revision wording
 * ("Adding" when there's no current revision, else the number) preserves the prior
 * per-row behavior.
 */
export default function buildConfirmUpdateColumns({ targetRevision, requiredVariableNames, consentCategoryEnabled }) {
  return [
    {
      name: 'Pipeline',
      selector: row => row.pipeline.name,
      grow: 2,
    },
    {
      name: 'Requires Attention',
      cell: row => (
        <RequiresAttentionCell
          pipelineId={row.pipeline.id}
          requiredVariableNames={requiredVariableNames}
          consentCategoryEnabled={consentCategoryEnabled}
        />
      ),
    },
    {
      name: 'Current Revision',
      selector: row => (row.currentRevision ? row.currentRevision : 'Adding'),
    },
    {
      name: 'New Revision',
      selector: () => targetRevision,
    },
  ];
}
